<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import eventBus from '@core/utils/eventBus.js'

defineOptions({
  name: 'PayView',
})

const { t } = useI18n()

const visible = ref(false)
const payurl = ref('')


const showPay = (src) => {
  visible.value = true
  payurl.value = src
}

const onCancel = () => {
  visible.value = false
}

window.showPay = showPay

// 支付页面所有地区尽量维护同一份代码
onMounted(() => {
  eventBus.on('pay', showPay)
})

onBeforeUnmount(() => {
  eventBus.off('pay', showPay)
})
</script>

<template>
  <van-popup
    class="bg-transparent popup-visible"
    transition="popup-zoom"
    v-model:show="visible"
    destroy-on-close
  >
    <div class="tips-common">
      <div class="desc">{{ t('pay.iframe.ready') }}</div>
      <div class="fx-center btn-box">
        <button class="btn-cancel btn-pill is-gray" @click="onCancel">{{ t('common.cancel') }}</button>
        <a class="link" :href="payurl" target="_blank">
          <button class="btn-confirm btn-pill is-pink">{{ t('common.open') }}</button>
        </a>
      </div>
    </div>
  </van-popup>
</template>

<style scoped lang="scss">
.tips-common {
  width: 1280px;
  height: 760px;
  border-radius: 40px;
  background: linear-gradient(180deg, #055844 20%, #008F66 100%);
  box-shadow: 0px 10px 10px 0px #00000014;
  padding: 14px 0 0;
}

.desc {
  margin: 0 auto;
  width: 1100px;
  height: 604px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FBCF3E;
  text-shadow: 0px 6px 10px #0000001A;
  text-align: center;

  font-weight: 500;
  font-size: 65px;
  line-height: 1.1;
}

.btn-box {
  margin: -53px auto 0;
  gap: 20px;
  padding: 0 40px;

  .btn-pill, .link {
    flex: 1;
  }

  .link {
    .btn-confirm {
      width: 100%;
    }
  }
}

.btn-confirm, .btn-cancel {
  font-weight: 500;
  font-size: 65px;
  color: #fff;
}
</style>
